document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-notify-panel]').forEach((panel) => {
    try {
      initNotifyMe(panel);
    } catch (error) {
      console.error('[notify-me] failed to initialize', error);
    }
  });
});

function initNotifyMe(panel) {
  const sectionId = panel.dataset.notifyPanel || '';
  const openBtn = document.getElementById('ProductNotifyButton-' + sectionId);
  const closeBtn = panel.querySelector('[data-notify-close]');
  const formView = panel.querySelector('[data-notify-form-view]');
  const successView = panel.querySelector('[data-notify-success]');
  const form = panel.querySelector('.password-gate__signup-form');
  const emailInput = panel.querySelector('[data-notify-email]');
  const emailError = panel.querySelector('[data-notify-error]');
  const submitBtn = panel.querySelector('[data-notify-submit]');
  const submitLabel = panel.querySelector('[data-notify-submit-label]');

  let closeTimer;

  function handleOutsideClick(event) {
    if (!panel.contains(event.target) && event.target !== openBtn) {
      closePanel();
    }
  }

  function handleKeydown(event) {
    if (event.key === 'Escape') closePanel();
  }

  function openPanel() {
    panel.hidden = false;
    requestAnimationFrame(() => {
      panel.classList.add('is-open');
    });
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      panel.classList.add('show-close');
    }, 3000);
    document.addEventListener('click', handleOutsideClick, true);
    document.addEventListener('keydown', handleKeydown);
  }

  function closePanel() {
    panel.classList.remove('is-open', 'show-close');
    clearTimeout(closeTimer);
    document.removeEventListener('click', handleOutsideClick, true);
    document.removeEventListener('keydown', handleKeydown);
    window.setTimeout(() => {
      panel.hidden = true;
    }, 400);
  }

  if (openBtn) {
    openBtn.addEventListener('click', (event) => {
      event.preventDefault();
      openPanel();
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closePanel);
  }

  if (form && emailInput) {
    form.noValidate = true;
    form.addEventListener(
      'submit',
      (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (submitBtn && submitBtn.disabled) return;

        if (emailError) emailError.hidden = true;

        if (!emailInput.checkValidity() || !emailInput.value.trim()) {
          emailInput.setAttribute('aria-invalid', 'true');
          if (emailError) emailError.hidden = false;
          return;
        }
        emailInput.removeAttribute('aria-invalid');

        setLoading(true);

        subscribeToRestock(form)
          .then((success) => {
            if (!success) throw new Error('subscribe_failed');
            if (formView) formView.hidden = true;
            if (successView) successView.hidden = false;
          })
          .catch(() => {
            if (emailError) {
              emailError.textContent = 'Something went wrong, please try again.';
              emailError.hidden = false;
            }
          })
          .finally(() => {
            setLoading(false);
          });
      },
      true
    );
  }

  function setLoading(isLoading) {
    if (submitBtn) submitBtn.disabled = isLoading;
    if (submitLabel) submitLabel.style.visibility = isLoading ? 'hidden' : 'visible';
    if (submitBtn) submitBtn.classList.toggle('password-gate__submit--loading', isLoading);
  }
}

function subscribeToRestock(form) {
  const formData = new FormData(form);

  return fetch(form.action, {
    method: form.method || 'post',
    body: formData,
    credentials: 'same-origin',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
  })
    .then((response) => response.ok)
    .catch(() => false);
}
